export enum EStatusRecebimentoMercadoria {
  EmDigitacao = 1,
  AguardandoConferencia = 2,
  ConferenciaEmAndamento = 3,
  Conferido = 4,
  Concluido = 5,
  Devolvido = 6,
  Cancelado = 7,
}
